
const TAP_WINDOW_MS = 1000;
const TAPS_REQUIRED = 4;

let didAttach = false;
const tapTimestamps: number[] = [];

export function recordProfileMenuUrlDebugTap(): void {
  const now = Date.now();
  tapTimestamps.push(now);
  while (tapTimestamps.length && now - tapTimestamps[0]! > TAP_WINDOW_MS) {
    tapTimestamps.shift();
  }
  if (tapTimestamps.length >= TAPS_REQUIRED) {
    tapTimestamps.length = 0;
    attachCurrentUrlToBody();
  }
}

/** Appends a plain div to `document.body` with `{ href, cvppwa }` as JSON (once). */
export function attachCurrentUrlToBody() {
  if (didAttach) return;
  didAttach = true;

  const el = document.createElement("div");
  el.className = "cvp-body-current-url";
  el.style.cssText =
    "font:11px/1.3 ui-monospace,monospace;word-break:break-all;padding:6px 8px;border-top:1px solid #ccc;background:#f8f8f8;color:#222;";
  const href = window.location.href;
  el.textContent = JSON.stringify({ href });
  document.body.appendChild(el);
}
